import loadGoogleMaps, {
  createGoogleMapsImageMarker,
  getGoogleMapsApiKey
} from '../../js/modules/google-maps-loader'
import { throttle, getMetaValue } from '../../js/modules/helper-functions.js'
import mapStyles from '../../js/search-app/mapStyles.json'

// Export component settings.
export const settings = {
  selector: '.js-properties-map',
  pinSelector: '.js-properties-map-pin',
}

const GOOGLE_MAPS_API_KEY = getGoogleMapsApiKey()

/**
 * Function initializes all elements in page.
 */
export default function lateInitAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
function init( element ) {

  loadGoogleMaps({ key: GOOGLE_MAPS_API_KEY })
    .then(( googleMaps ) => {
      window.google.maps = googleMaps
      initMap( element )
    })

  return element
}

/**
 * Initialize the Map.
 */
function initMap( element ) {
  let map = renderMap( element )
    window.addEventListener( 'resize', throttle(() => {
      centerMap( map )
    }, 300 ))
}

/**
 * Render the Google Map.
 *
 * @param {DOMNode} element
 */
function renderMap( element ) {
  const markers = element.querySelectorAll( settings.pinSelector )

  const args = {
    zoom: 10,
    styles: mapStyles,
    mapTypeControl: false,
    scaleControl: true,
    zoomControl: true,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    draggableCursor: 'default',
    gestureHandling: 'cooperative',
    center: new window.google.maps.LatLng( 0, 0 )
  }

  const map = new window.google.maps.Map( element, args )

  map.markers = []

  // Add markers
  Array.from( markers ).forEach(( marker ) => {
    const newMarker = addMarker( marker, map )
    initMarkerClickListener( newMarker )
  })

  // Center map
  centerMap( map )

  return map
}

/**
 * Initialize the click listeners for the markers.
 *
 * @param {google.maps.OverlayView} marker
 */
function initMarkerClickListener( marker ) {
  marker.addListener( 'click', function() {
    window.open( marker.href )
  })
  return marker
}

/**
 * Add marker to the map.
 *
 * @param {DOMNode} marker
 * @param {google.maps.Map} map
 */
function addMarker( marker, map ) {
  const latlng = new window.google.maps.LatLng( marker.dataset.lat, marker.dataset.lng )
  const styleDir = getMetaValue( 'wp-stylesheet-directory-uri' )
  const pin = `${styleDir}/assets/src/img/icons/png/green/location.png`

  const newMarker = createGoogleMapsImageMarker( window.google.maps, {
    position: latlng,
    map: map,
    href: marker.getAttribute( 'href' ),
    src: pin,
    size: 36
  })

  map.markers.push( newMarker )

  return newMarker
}

/**
 * Center the map.
 *
 * @param {google.maps.Map} map
 */
function centerMap( map ) {
  let bounds = new window.google.maps.LatLngBounds()
  map.markers.forEach( function( marker ) {
    bounds.extend( marker.position )
  })

  if ( map.markers.length === 1 ) {
    map.setCenter( bounds.getCenter())
  } else {
    map.fitBounds( bounds )
  }

}
